import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';

import QuestionnaireStepHeader from '../../QuestionnaireStepHeader';
import { Buttons } from '../Buttons';
import QuestionnaireContext from '../../QuestionnaireContext';

const RadioCardSubPage = ({ data, onPush, onRemove }) => {
  const { setParam } = useContext(QuestionnaireContext);
  const [isValid, setIsValid] = useState(
    data.reduce((prev, next) => {
      return { ...prev, [next.questionId]: true };
    }, {}),
  );

  useEffect(() => {
    setParam('isHeaderVisible', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (values(isValid).includes(true)) {
      setParam('isValidate', true);
    } else {
      setParam('isValidate', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid]);

  const handleOnChange = (id, selectedValues) => {
    setIsValid({
      ...isValid,
      [id]: selectedValues.length > 0,
    });
  };

  return data.map(({ questionLabel, questionSubLabel, options, questionId }) => (
    <React.Fragment key={questionId}>
      <QuestionnaireStepHeader label={questionLabel} subLabel={questionSubLabel} />
      <Buttons
        options={values(options)}
        questionId={questionId}
        onPush={onPush}
        onRemove={onRemove}
        handleValidation={false}
        onChange={selectedValues => handleOnChange(questionId, selectedValues)}
      />
    </React.Fragment>
  ));
};

RadioCardSubPage.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      subLabel: PropTypes.string,
      options: PropTypes.object.isRequired,
      questionId: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onPush: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export { RadioCardSubPage };
